import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prop-types
function ActiveDaysMessage({
  weekDays,
  repeatEvery,
  repeatEveryCount,
  startEventDate,
  endRecurrenceEventDate,
}) {
  const days = [];
  let count = 0;
  const styles = { color: '#0997ba', fontWeight: 'bold' };

  // eslint-disable-next-line react/prop-types
  weekDays.forEach((day) => {
    if (day.active === true) {
      days.push(day.name);
      count += 1;
    }
  });

  if (repeatEvery === 'day') {
    if (repeatEveryCount > 1)
      return (
        <>
          <label>Occurs every </label>
          <label style={styles}>{repeatEveryCount} days</label>
          <label> until</label>
        </>
      );

    // eslint-disable-next-line react/prop-types
    if (count === weekDays.length) return <label>Occurs every days until</label>;

    if (repeatEveryCount === 1)
      return (
        <>
          <label>Occurs every</label>
          <label style={styles}>{` ${days.join(', ')}`}</label>
          <label> until</label>
        </>
      );
  }

  if (repeatEvery === 'week')
    return (
      <>
        <label>
          Occurs every {repeatEveryCount}
          {repeatEveryCount > 1 ? ' weeks' : ' week'} the
        </label>
        <label style={styles}>{` ${days.join(', ')}`}</label>
        <label> until</label>
      </>
    );

  if (repeatEvery === 'month')
    // eslint-disable-next-line react/prop-types
    return (
      <label>
        Occurs every {repeatEveryCount > 1 ? `${repeatEveryCount} months` : ' month'} until
      </label>
    );
  if (repeatEvery === 'year')
    return (
      <label>
        {/* eslint-disable-next-line react/prop-types */}
        Occurs every {startEventDate.format('D')} {startEventDate.format('MMMM')} until{' '}
        {endRecurrenceEventDate.format('L')}
      </label>
    );
  return '';
}

ActiveDaysMessage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  weekDays: PropTypes.any.isRequired,
  repeatEvery: PropTypes.string.isRequired,
  repeatEveryCount: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  startEventDate: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  endRecurrenceEventDate: PropTypes.any.isRequired,
};

export default ActiveDaysMessage;
